/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_Disabled_No_Create_PermissionInputs */

const vi_order_recreate_disabled_no_create_permission = /** @type {(inputs: Order_Recreate_Disabled_No_Create_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền tạo đơn hàng`)
};

/**

* @param {Order_Recreate_Disabled_No_Create_PermissionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_disabled_no_create_permission = /** @type {((inputs?: Order_Recreate_Disabled_No_Create_PermissionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_Disabled_No_Create_PermissionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_disabled_no_create_permission(inputs)
});